import MarkdownIt from 'markdown-it';
import { useMemo } from 'react';

interface MarkdownPreviewProps {
  content: string;
}

export function MarkdownPreview({ content }: MarkdownPreviewProps) {
  const html = useMemo(() => {
    const md = new MarkdownIt({ html: false });
    return md.render(content);
  }, [content]);

  return (
    <div
      className="prose prose-sm max-w-none text-content-primary"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: markdown-it configured with html:false escapes inline HTML in source
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
